import {
    buildConfigSlice,
    useConfigSlice,
} from 'widgets/store/configuration/configSlice';
import { WidgetType } from 'widgets/WidgetType';
import { selectVenueTypeCapsuleState } from 'widgets/venueAnalysis/capsules/venueTypeCapsule/store/selectors';
import {
    initialVenueAnalysisCapsuleConfigState,
    VenueAnalysisCapsuleConfigState,
} from 'widgets/venueAnalysis/capsules/store/VenueAnalysisCapsuleConfigState';

export const buildVenueTypeCapsuleConfigSlice = () =>
    buildConfigSlice<VenueAnalysisCapsuleConfigState>(
        WidgetType.VENUE_TYPE_CAPSULE,
        selectVenueTypeCapsuleState,
        initialVenueAnalysisCapsuleConfigState
    );

export const useVenueTypeCapsuleConfigSlice = () =>
    useConfigSlice(buildVenueTypeCapsuleConfigSlice());
